import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconArrowDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1428_2624)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.49219 11.8398C9.21875 12.0859 8.80859 12.0859 8.5625 11.8398L4.1875 7.46484C3.91406 7.21875 3.91406 6.78125 4.1875 6.53516C4.43359 6.28906 4.84375 6.28906 5.08984 6.53516L9 10.4453L12.9102 6.53516C13.1836 6.28906 13.5938 6.28906 13.8398 6.53516C14.1133 6.80859 14.1133 7.21875 13.8398 7.46484L9.46484 11.8398H9.49219Z",
			fill: "#868686"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1428_2624",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgIconArrowDown;
